import * as printJS from 'print-js';

export function printPdf(blobUrl: string, title?: string): void {
  if (title) {
    const originalTitle = document.title;
    document.title = title;

    const titleEl = document.querySelector('title');
    let observer: MutationObserver | undefined;
    if (titleEl) {
      observer = new MutationObserver(() => {
        if (document.title !== title) {
          document.title = title;
        }
      });
      observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
    }

    const cleanup = () => {
      observer?.disconnect();
      document.title = originalTitle;
    };
    const safetyTimeout = setTimeout(cleanup, 60_000);

    printJS({
      printable: blobUrl,
      type: 'pdf',
      onPrintDialogClose: () => { clearTimeout(safetyTimeout); cleanup(); },
      onError: () => { clearTimeout(safetyTimeout); cleanup(); },
    });
  } else {
    printJS(blobUrl);
  }
}
